import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import H6 from '@base/H6/H6';
import Button from '@base/Button/Button';
import { setModalState } from '@actions/quizTaking';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import Info from '@icon/Info';
import { Spacings } from '@styles/index';
import useOngoingSection from '../Common/useOngoingSection';
import { MODAL_TYPES } from '../../constants';

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Wrapper = styled(Flex)`
  margin: 0px 0px ${Spacings.SPACING_6B} 0px;
`;

const InstructionIcon = styled(Info)`
  cursor: pointer;
`;

const Title = styled(H6)`
  margin: 0 ${Spacings.SPACING_3B};
`;

const Header = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const { hasOngoingSectional, isLastOngoingSection } = useOngoingSection();

  const handleOnInstructionsClick = () => {
    dispatch(
      setModalState({
        type: MODAL_TYPES.QUIZ_INSTRUCTION,
        data: {}
      })
    );
  };

  const handleOnEndClick = () => {
    dispatch(
      setModalState({
        type: MODAL_TYPES.QUIZ_FINISH_CONFIRMATION,
        data: {}
      })
    );
  };

  return (
    <Wrapper>
      <Flex>
        <InstructionIcon
          size={Spacings.SPACING_5B}
          onClick={handleOnInstructionsClick}
          color="var(--color-text-primary)"
        />
        <Title lineClamp={1}>{quizDetails.title}</Title>
      </Flex>

      <Button
        grid={3}
        variant="hollow"
        color="black"
        label={
          hasOngoingSectional && !isLastOngoingSection
            ? 'End section'
            : 'End test'
        }
        onClick={handleOnEndClick}
      />
    </Wrapper>
  );
};

export default Header;
